import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import {
  IStationDto,
  selectedTableRowsIdsAtomFamily,
  tableRowsAtomFamily,
} from "@ryde/shared";

/** Stations currently selected in the grid — the ones rendered as markers on the map. */
export const useStationsMapSelectedStations = () => {
  const selectedIds = useRecoilValue(selectedTableRowsIdsAtomFamily("station"));
  const tableRows = useRecoilValue(tableRowsAtomFamily("station"));

  const selectedStations = useMemo(() => {
    if (!selectedIds?.length || !tableRows?.length) {
      return [] as IStationDto[];
    }

    const selectedSet = new Set(selectedIds);

    return (tableRows as unknown as IStationDto[]).filter(row =>
      selectedSet.has(row.id),
    );
  }, [selectedIds, tableRows]);

  return { selectedStations };
};
